var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',[(_vm.$ui.layout === 'main')?_c('main-layout'):(_vm.$ui.layout === 'minimal')?_c('minimal-layout',{staticStyle:{"height":"100%"}}):_vm._e(),_c('app-dialogs'),_c('app-notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }